module.exports = __webpack_public_path__ + "static/warning-9d77582b4f4c9431eeb9884462e1d57f.png";